export const EditIcon: React.FC = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.546 5.49259L8.4855 4.43209L1.5 11.4176V12.4781H2.5605L9.546 5.49259ZM10.6065 4.43209L11.667 3.37159L10.6065 2.31109L9.546 3.37159L10.6065 4.43209ZM3.1815 13.9781H0V10.7958L5.03813 5.75772L10.0763 0.71959C10.2169 0.578987 10.4076 0.5 10.6065 0.5C10.8054 0.5 10.9961 0.578987 11.1368 0.71959L13.2585 2.84134C13.3991 2.98199 13.4781 3.17272 13.4781 3.37159C13.4781 3.57046 13.3991 3.76119 13.2585 3.90184L3.1815 13.9781Z"
      fill="#0054A5"
    />
  </svg>
);
